import React, { Component } from 'react'
import Helmet from 'react-helmet'
import config from '../utils/siteConfig'

class SEO extends Component {
  render() {
      const data = this.props.data || {};
      const pagePath = this.props.pagePath || '';
      /**
       * If SEO data from contentful does exists and was passed in by the parent component then
       * include the data from the seo properties.
       *
       * Set prop values to locally scoped const values and
       * define defaults in case values are not provided by contentful.
       */

      // Set Default OpenGraph Parameters for Fallback
      const image = config.siteUrl + config.shareImage
      const imgWidth = config.shareImageWidth
      const imgHeight = config.shareImageHeight
      const pageUrl = config.siteUrl + pagePath

      // Basic Meta Tags
      // Contentful Value First, Config Values second
      const title = data.title ? data.title : config.siteTitle
      const metaDescription = data.metaDescription ? data.metaDescription : config.siteDescription

      // Open Graph, Facebook, Twitter, Pintrest
      // Pinterest will pick up the FB OG tags. You can explicitly define those if you like
      const ogType = data.ogType ? data.ogType : 'website'
      const ogTitle = data.ogTitle ? data.ogTitle : config.siteTitle
      const ogDescription = data.ogDescription ? data.ogDescription : config.siteDescription
      const ogURL = data.ogUrl ? data.ogUrl : pageUrl
      const ogImage = data.ogImage ? `https:${data.ogImage.fluid.src}` : image
      const ogImageAlt = data.ogImage ? data.ogImage.title : config.siteTitle

      // Default Website Schema
      const schemaOrgJSONLD = [
        {
          '@context': 'http://schema.org',
          '@type': "Restaurant",
          url: pageUrl,
          name: config.siteTitle,
          alternateName: config.siteTitleAlt,
          logo: image,
          image: image,
          description: metaDescription,
          priceRange: "$",
          acceptsReservations: "No",
          menu: "https://www.bambooasia.com/order-online/",
          servesCuisine: "Asian Fusion",
          telephone: "415-772-9134",
          openingHours:
            [
              "Mo, Tu, We, Th, 08:00-20:00",
              "Fri 11:00-15:00"
            ],
          address : {
            "@type": "PostalAddress",
            addressLocality: "San Francisco",
            addressRegion: "California",
            addressCountry: "United-States",
          }
        },
      ];

      return (
        <Helmet title={title}>
          {/* Basic Meta Tags */}
          <meta name="image" content={image} />
          <meta name="description" content={metaDescription} />

          {/* Schema.org tags */}
          <script type="application/ld+json">
            {JSON.stringify(schemaOrgJSONLD)}
          </script>

          {/* Google Meta Tags */}
          <meta itemProp="name" content={title} />
          <meta itemProp="description" content={metaDescription} />
          <meta itemProp="image" content={ogImage} />

          {/* Facebook and Pintrest Meta Tags */}
          <meta property="og:type" content={ogType} />
          <meta property="og:title" content={ogTitle} />
          <meta property="og:description" content={ogDescription} />
          <meta property="og:url" content={ogURL} />
          <meta property="og:image" content={ogImage} />
          <meta property="og:image:width" content={imgWidth} />
          <meta property="og:image:height" content={imgHeight} />
          <meta property="og:image:alt" content={ogImageAlt} />

          {/* Twitter Cards */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:creator"
            content={config.userTwitter ? config.userTwitter : ''}
          />
          <meta name="twitter:title" content={ogTitle} />
          <meta name="twitter:description" content={ogDescription} />
          <meta name="twitter:image" content={`https:${ogImage}`} />
        </Helmet>
      )
    }
}

export default SEO;
